<div class="accordion mb-2" id="accessLogs">
    <ng-container *ngFor="let log of accessLogs; let i = index">
        <div class="accordion-item">
            <h2 class="accordion-header" id="accesslog-heading-{{i}}">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    [attr.data-bs-target]="'#accesslog-panel-'+i" aria-expanded="false"
                    [attr.aria-controls]="'accesslog-panel-'+i" [attr.id]="'accesslog-btn-'+i">
                    {{ log.loggedDatetime | date: "dd/MM/yyyy HH:mm" }} - {{ log.userName }}
                </button>
            </h2>
            <div id="accesslog-panel-{{i}}" class="accordion-collapse collapse" data-bs-parent="#accessLogs"
                role="region" [attr.aria-labelledby]="'accesslog-btn-'+i">
                <div class="accordion-body bg-body-tertiary">
                    {{ log.activity }}
                </div>
            </div>
        </div>
    </ng-container>
</div>